import React from "react";
import { useParams, useSearchParams } from "react-router-dom";
import DirectChatPanel from "components/chat/DirectChatPanel";

export default function DirectChatThreadPage() {
  const params = useParams();
  const [searchParams] = useSearchParams();
  const conversationId = params.conversationId;
  const title = searchParams.get("title");

  if (!conversationId) return null;

  return (
    <div className="w-full p-6">
      <DirectChatPanel conversationId={conversationId} peerName={title} />
    </div>
  );
}
